import { render, staticRenderFns } from "./newsdetail1.vue?vue&type=template&id=3f53ce38&scoped=true"
import script from "./newsdetail1.vue?vue&type=script&lang=js"
export * from "./newsdetail1.vue?vue&type=script&lang=js"
import style0 from "./newsdetail1.vue?vue&type=style&index=0&id=3f53ce38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f53ce38",
  null
  
)

export default component.exports